import { render, staticRenderFns } from "./reports-metrics.vue?vue&type=template&id=67a80e91&scoped=true"
import script from "./reports-metrics.vue?vue&type=script&lang=js"
export * from "./reports-metrics.vue?vue&type=script&lang=js"
import style0 from "./reports-metrics.vue?vue&type=style&index=0&id=67a80e91&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a80e91",
  null
  
)

export default component.exports